export default __webpack_public_path__ + "static/media/icons-document-management.e402b39b.svg";